const cfiRegex = [
  /^CB[A-Z]{4}$/,
  /^CE[A-Z]{4}$/,
  /^CF[A-Z]{4}$/,
  /^CH[A-Z]{4}$/,
  /^CI[A-Z]{4}$/,
  /^CM[A-Z]{4}$/,
  /^CP[A-Z]{4}$/,
  /^CS[A-Z]{4}$/,
  /^DA[A-Z]{4}$/,
  /^DB[A-Z]{4}$/,
  /^DC[A-Z]{4}$/,
  /^DD[A-Z]{4}$/,
  /^DE[A-Z]{4}$/,
  /^DG[A-Z]{4}$/,
  /^DM[A-Z]{4}$/,
  /^DN[A-Z]{4}$/,
  /^DS[A-Z]{4}$/,
  /^DT[A-Z]{4}$/,
  /^DW[A-Z]{4}$/,
  /^DY[A-Z]{4}$/,
  /^EC[A-Z]{4}$/,
  /^ED[A-Z]{4}$/,
  /^EF[A-Z]{4}$/,
  /^EL[A-Z]{4}$/,
  /^EM[A-Z]{4}$/,
  /^EP[A-Z]{4}$/,
  /^ES[A-Z]{4}$/,
  /^EY[A-Z]{4}$/,
  /^FC[A-Z]{4}$/,
  /^FFB[A-Z]{3}$/,
  /^FFC[A-Z]{3}$/,
  /^FFD[A-Z]{3}$/,
  /^FFF[A-Z]{3}$/,
  /^FFI[A-Z]{3}$/,
  /^FFM[A-Z]{3}$/,
  /^FFN[A-Z]{3}$/,
  /^FFO[A-Z]{3}$/,
  /^FFS[A-Z]{3}$/,
  /^FFV[A-Z]{3}$/,
  /^FFW[A-Z]{3}$/,
  /^HC[A-Z]{4}$/,
  /^HCI[A-Z]{3}$/,
  /^HCU[A-Z]{3}$/,
  /^HE[A-Z]{4}$/,
  /^HF[A-Z]{4}$/,
  /^HM[A-Z]{4}$/,
  /^HR[A-Z]{4}$/,
  /^HT[A-Z]{4}$/,
  /^JC[A-Z]{2}F[A-Z]{1}$/,
  /^JC[A-Z]{2}S[A-Z]{1}$/,
  /^JE[A-Z]{2}C[A-Z]{1}$/,
  /^JE[A-Z]{2}F[A-Z]{1}$/,
  /^JE[A-Z]{2}S[A-Z]{1}$/,
  /^JF[A-Z]{4}$/,
  /^JR[A-Z]{2}F[A-Z]{1}$/,
  /^JRIXF[A-Z]{1}$/,
  /^JRMXF[A-Z]{1}$/,
  /^JR[A-Z]{2}S[A-Z]{1}$/,
  /^JT[A-Z]{2}C[A-Z]{1}$/,
  /^JT[A-Z]{2}F[A-Z]{1}$/,
  /^O[A-Z]{2}B[A-Z]{2}$/,
  /^O[A-Z]{2}C[A-Z]{2}$/,
  /^O[A-Z]{2}D[A-Z]{2}$/,
  /^O[A-Z]{2}F[A-Z]{2}$/,
  /^O[A-Z]{2}I[A-Z]{2}$/,
  /^O[A-Z]{2}M[A-Z]{2}$/,
  /^O[A-Z]{2}N[A-Z]{2}$/,
  /^O[A-Z]{2}O[A-Z]{2}$/,
  /^O[A-Z]{2}S[A-Z]{2}$/,
  /^O[A-Z]{2}T[A-Z]{2}$/,
  /^O[A-Z]{2}W[A-Z]{2}$/,
  /^OM[A-Z]{4}$/,
  /^RA[A-Z]{4}$/,
  /^RD[A-Z]{4}$/,
  /^RF[A-Z]{4}$/,
  /^RM[A-Z]{4}$/,
  /^RP[A-Z]{4}$/,
  /^RS[A-Z]{4}$/,
  /^RW[A-Z]{4}$/,
  /^SC[A-Z]{1}C[A-Z]{2}$/,
  /^SC[A-Z]{1}M[A-Z]{2}$/,
  /^SC[A-Z]{1}T[A-Z]{2}$/,
  /^SE[A-Z]{4}$/,
  /^SF[A-Z]{4}$/,
  /^SM[A-Z]{4}$/,
  /^SR[A-Z]{4}$/,
  /^SRC[A-Z]{1}C[A-Z]{1}$/,
  /^SRC[A-Z]{1}S[A-Z]{1}$/,
  /^SRD[A-Z]{1}C[A-Z]{1}$/,
  /^SRD[A-Z]{1}S[A-Z]{1}$/,
  /^SRG[A-Z]{1}S[A-Z]{1}$/,
  /^SRH[A-Z]{1}S[A-Z]{1}$/,
  /^SRZ[A-Z]{1}S[A-Z]{1}$/,
  /^ST[A-Z]{1}T[A-Z]{2}$/,
  /^ST[A-Z]{1}C[A-Z]{2}$/,
  /^ITNXXX$/,
];

export function checkCfiValidity(value: string | undefined | null) {
  if (value === '' || !value) {
    return false;
  }

  return !!cfiRegex.find((regex) => regex.test(value));
}
